module.exports = __webpack_public_path__ + "img/pin-dino.8f68a0be.svg";